import React, { SVGProps } from 'react';
import Icon from '@ant-design/icons';
import { CustomIconComponentProps } from '@ant-design/icons/es/components/Icon';

import { IconProps } from 'components/assets/Icons/Icons';

/* eslint-disable max-len */
const ReportIsReadyIconSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 100 100" version="1.1">
        <defs>
            <path id="jzpgdqlhaa" d="M0 0L37 0 37 47 0 47z" />
            <path id="6pnva9v51c" d="M0 47L37 47 37 0 0 0z" />
        </defs>
        <g fill="none" fillRule="evenodd">
            <g>
                <path
                    fill="#E7E7F6"
                    d="M100 50c0 27.614-22.386 50-50 50S0 77.614 0 50 22.386 0 50 0s50 22.386 50 50"
                />
                <g>
                    <g transform="translate(25 26) translate(8)">
                        <path
                            fill="#FFF"
                            d="M3.15 46C1.964 46 1 45.036 1 43.85V3.15C1 1.964 1.964 1 3.15 1h30.7C35.036 1 36 1.964 36 3.15v40.7c0 1.186-.964 2.15-2.15 2.15H3.15z"
                        />
                        <g>
                            <mask id="kq2w3tvpdb" fill="#fff">
                                <use xlinkHref="#jzpgdqlhaa" />
                            </mask>
                            <path
                                fill="#49565D"
                                d="M33.85 0H3.15C1.41 0 0 1.41 0 3.15v40.7C0 45.59 1.41 47 3.15 47h30.7c1.74 0 3.15-1.41 3.15-3.15V3.15C37 1.41 35.59 0 33.85 0m0 2c.634 0 1.15.516 1.15 1.15v40.7c0 .634-.516 1.15-1.15 1.15H3.15C2.516 45 2 44.484 2 43.85V3.15C2 2.516 2.516 2 3.15 2h30.7"
                                mask="url(#kq2w3tvpdb)"
                            />
                        </g>
                        <mask id="68iywryspd" fill="#fff">
                            <use xlinkHref="#6pnva9v51c" />
                        </mask>
                        <path
                            fill="#49565D"
                            d="M25 14L32 14 32 12 25 12zM5 14L22 14 22 12 5 12zM5 8L32 8 32 6 5 6zM14 20L32 20 32 18 14 18z"
                            mask="url(#68iywryspd)"
                        />
                    </g>
                    <g>
                        <path
                            fill="#676DFD"
                            d="M0 14C0 6.269 6.268 0 14 0c7.731 0 14 6.269 14 14 0 7.732-6.269 14-14 14-7.732 0-14-6.268-14-14z"
                            transform="translate(25 26) translate(0 24)"
                        />
                        <path
                            stroke="#FFF"
                            strokeLinecap="round"
                            strokeWidth="2"
                            d="M19.246 11.262L12.146 18.362 8.753 14.968"
                            transform="translate(25 26) translate(0 24)"
                        />
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const ReportIsReadyIcon = (props: IconProps) => (
    <Icon component={ReportIsReadyIconSvg} {...props} />
);
